import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class LawsuitTypes extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.options.length = 0

		this.loading = true
		const res = await api.get('/api/lawsuit-types')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				const hasTrial = option.trials_aggregate.aggregate.count > 0
				Object.assign(option, { loading: false, hasTrial: hasTrial })
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.modalLoading = false
	}

	openEdit(lawsuitTypes) {
		this.form.id = lawsuitTypes.id
		this.form.name = lawsuitTypes.name
		this.$bvModal.show('modal-edit-lawsuitTypes')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-lawsuitTypes')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const lawsuitTypes = this.options.find(
					(l) => l.id === this.form.id,
				)

				const res = await api.put(
					'/api/lawsuit-types/' + lawsuitTypes.id,
					this.form,
				)
				if (res.ok) {
					lawsuitTypes.name = this.form.name
					this.$bvModal.hide('modal-edit-lawsuitTypes')
					this.$bvToast.toast('Tipo de ação salvo com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const res = await api.post('/api/lawsuit-types/', this.form)
				if (res.ok) {
					this.options.push({
						id: res.id,
						name: this.form.name,
						loading: false,
					})

					// @ts-ignore
					fuse = new Fuse(this.options, {
						keys: ['name'],
					})

					this.$bvModal.hide('modal-new-lawsuitTypes')
					this.$bvToast.toast(
						'Tipo de ação adicionado com sucesso!',
						{
							title: 'Sucesso!',
							autoHideDelay: 2500,
							appendToast: true,
							variant: 'success',
							toaster: 'b-toaster-top-center',
							solid: true,
						},
					)
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async deleteLawsuitTypes(lawsuitTypes, index) {
		const res = await api.delete('/api/lawsuit-types/', lawsuitTypes)
		if (res.ok) {
			this.options.splice(index, 1)
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast(
				'Tipo de ação excluído com sucesso!',
				{
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				},
			)
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}

	mounted() {
		this.init()
	}
}
